/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { useNavigate } from "react-router-dom";

/* Components */
import UCGrid from "../../../../ucgrid";
import ReportsNoBookings from "../../../../reportsNoBookings";

/* Helpers */
import { formatUTCDateTime } from "../../../../../helpers/general";

/* Styles */
import styles from "./styles.js"
import { FormattedMessage } from 'react-intl';

const FlightSegmentsGrid = ({ gridOptions, setGridOptions, flightSegmentsResponse, onRowClick, handleSort, defaultSort }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.flightSegmentsGrid}>
      <UCGrid
        gridName="flightSegmentsGrid"
        data={flightSegmentsResponse?.results}
        columns={flightSegmentsResponse?.columns}
        actions={flightSegmentsResponse?.actions}
        handlePageChange={(page) => {
          setGridOptions({ ...gridOptions, page });
          page > 1
            ? navigate(`/app/reports/flight-segments?page=${page}`)
            : navigate(`/app/reports/flight-segments`);
        }}
        setSelectedRow={setSelectedRow}
        spinner="flightSegmentsGridSpinner"
        customColumns={{
          passengerName: (row) => (
            <div className={classes.details}>
              <p>{row.passengerName || ''}</p>
            </div>
          ),
          scheduledArrivalTimeUTC: (row) => formatUTCDateTime(row.scheduledArrivalTimeUTC),
          scheduledDepartureTimeUTC: (row) => formatUTCDateTime(row.scheduledDepartureTimeUTC),
          provider: (row) => {
            return row?.provider && <FormattedMessage id={`reports.provider.${row.provider}`} />;
          },
        }}
        columnCustomWidth={{
          recordLocator: '185px !important',
          passengerName: '230px !important',
          arrivalCountry: '185px !important',
          arrivalCity: '185px !important',
          DEPARTMENT_NAME: '185px !important',
          EMPLOYEE_NUMBER: '185px !important',
        }}
        noDataComponent={<ReportsNoBookings />}
        showHeader={true}
        persistTableHead={false}
        onRowClick={onRowClick}
        handleSort={handleSort}
        defaultSort={defaultSort}
      />
    </div>
  );
}

export default FlightSegmentsGrid;
